import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  TableContainer,
} from "@mui/material";
import { FC } from "react";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import TableComponent from "../component/TableComponent";
import { useForm } from "react-hook-form";
import { agingReportPdf, agingReportTable } from "./services";
import useRepotFile from "../hooks/reportFileHook";
import { useMutation, useQuery } from "react-query";
import {
  getInsuranceByParams,
  getInsuranceType as getAllinsuranceType,
} from "../../Insurance/services";
import { searchFields } from "../../Insurance/ClaimListing/fieldData";
import useAuthentication from "@hooks/useAuthentication";
import { AgingReportFormType, defaultValues } from "./types";
type ChangeParamsType = {
  target: { value: any; name: string };
  name: string;
};

const AgingReportNew: FC = () => {
  const {
    handleSubmit,
    control,
    reset,
    resetField,
    watch,
    clearErrors,
    getValues,
  } = useForm<AgingReportFormType>({
    defaultValues,
  });
  const { user } = useAuthentication();
  const { mutate: getAgingReportPdf, isLoading: pdfLoading } = useRepotFile({
    apiFunction: agingReportPdf,
  });

  const insType = watch("insuranceType");
  const isAllTicked = watch("all");

  const {
    mutate: getAgingReportTable,
    data: agingReportData,
    isLoading: agingReportTableDataLoading,
    reset: resetMutation,
  } = useMutation(agingReportTable);

  const { data: insuranceType, isLoading: insuranceTypeLoading } = useQuery(
    ["insuranceTypeInAgingReport"],
    getAllinsuranceType,
    {
      refetchOnWindowFocus: false,
    }
  );

  const {
    mutate: getReveiverByType,
    data: receiver,
    isLoading: receiverLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: getPayerByType,
    data: payer,
    isLoading: payerLoadig,
  } = useMutation(getInsuranceByParams);

  const clearField = (fields: (keyof typeof defaultValues)[]) => {
    fields.forEach((f) => {
      resetField(f);
    });
  };

  const handleInsurnceTypeChange = (params: ChangeParamsType) => {
    const {
      target: { value },
    } = params;
    clearField(["payer", "receiver"]);
    const allData = watch();
    if (Boolean(value)) {
      if (value.id == 1) {
        getReveiverByType({
          typeId: value?.id,
        });
      } else {
        getPayerByType({
          typeId: value?.id,
        });
      }
      reset({
        ...allData,
      });
    } else {
      reset({
        ...allData,
        [searchFields.insuranceType.name]: null,
      });
    }
  };

  const handleApiCall = ({
    value,
    type,
  }: {
    value?: AgingReportFormType;
    type: "form" | "pdf";
  }) => {
    if (type == "form" && Boolean(value)) {
      const formData = {
        insuranceType: value?.insuranceType?.name || null,
        receiver: value?.receiver?.name || value?.payer?.name || null,
        payer: value?.payer?.name || null,
        clinicId: Number(user?.clinicId),
      };
      getAgingReportTable(formData);
    } else {
      const data = getValues();
      const formData = {
        insuranceType: data?.insuranceType?.name || null,
        receiver: data?.receiver?.name || data?.payer?.name || null,
        payer: data?.payer?.name || null,
        clinicId: Number(user?.clinicId),
      };
      getAgingReportPdf(formData);
    }
  };

  function onSubmit(value: AgingReportFormType) {
    handleApiCall({ value, type: "form" });
  }

  const handleReset = () => {
    resetMutation();
    reset(defaultValues);
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Aging Report
          </Typography>
        </div>
        <form
          className="grid grid-cols-12 gap-3 p-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-span-3">
            <CustomFormField
              name="insuranceType"
              control={control}
              options={insuranceType?.response || []}
              loading={insuranceTypeLoading}
              element="autocomplete"
              fieldProps={{ label: "Insurance Type" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: isAllTicked
                  ? false
                  : searchFields.insuranceType.rules.required,
                onChange: handleInsurnceTypeChange,
              }}
            />
          </div>
          <div className={insType?.id == 1 ? "col-span-3" : "hidden"}>
            <CustomFormField
              control={control}
              options={receiver?.response || []}
              loading={receiverLoadig}
              name="receiver"
              fieldProps={{ label: "Receiver" }}
              element="autocomplete"
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: isAllTicked
                  ? false
                  : insType?.id == 1
                    ? "Receiver required"
                    : false,
                onChange: () => {
                  clearField(["payer"]);
                  getPayerByType({
                    typeId: 2,
                  });
                },
              }}
            />
          </div>
          <div className="col-span-3">
            <CustomFormField
              name="payer"
              control={control}
              options={payer?.response || []}
              loading={payerLoadig}
              element="autocomplete"
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              fieldProps={{
                label: insType?.id == 1 ? "Payer" : "Insurance",
              }}
              rules={{
                required: isAllTicked
                  ? false
                  : `${insType?.id == 1 ? "Payer" : "Insurance"} required`,
              }}
            />
          </div>
          <div className="">
            <CustomFormField
              control={control}
              name="all"
              fieldProps={{ label: "All" }}
              element="checkbox"
              rules={{
                required: false,
                onChange: () => {
                  clearErrors();
                },
              }}
            />
          </div>

          <div className={"col-span-full flex justify-end gap-2"}>
            <Button
              disabled={agingReportTableDataLoading}
              endIcon={
                agingReportTableDataLoading && (
                  <CircularProgress
                    sx={{ color: (theme) => theme.palette.background.paper }}
                    size={18}
                  />
                )
              }
              size="small"
              type="submit"
            >
              Search
            </Button>
            <Button
              onClick={handleReset}
              size="small"
              type="reset"
              color="error"
            >
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={pdfLoading || !Boolean(agingReportData?.response?.length)}
            endIcon={pdfLoading && <CircularProgress size={18} />}
            onClick={()=>handleApiCall({type:"pdf"})}
          >
            pdf
          </Button>
        </div>
        <TableComponent
          loading={agingReportTableDataLoading}
          data={agingReportData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default AgingReportNew;

const heading = [
  {
    heading: "Claim Id",
    key: "claim_id",
  },
  {
    heading: "Claim Submit Id",
    key: "claimSubmitId",
  },
  {
    heading: "PHN No",
    key: "phnNo",
  },
  {
    heading: "Name",
    key: "Name",
  },
  {
    heading: "Insurance Type",
    key: "InsType",
  },
  {
    heading: "Insurance Name",
    key: "InsuranceName",
  },
  {
    heading: "Insurance Share",
    key: "InsuranceShare",
  },
  {
    heading: "Days",
    key: "days",
  },
  {
    heading: "Claim Submitted Date",
    key: "claimSubmittedDate",
    date: "DD-MM-YYYY hh:mm A",
    format: "DD/MM/YYYY HH:mm A", // 2025-05-06T02:09:14.000+00:00
  },
];
